import { isBedbankOffer } from 'lib/offer/offerTypes'

/**
 * Builds search parameters for the "Select dates" functionality when a user clicks
 * on a property to select dates for it. This is used across various search pages.
 *
 * @param offer - The offer that was clicked
 * @returns An object containing propertyId, propertyName, and the search params string for mobile
 */
export function buildSelectDatesSearchParams(
  offer: App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary | App.VillaOffer | App.VillaOfferSummary,
): {
  propertyId: string
  propertyName: string
  propertySearchItem: App.SearchItem
  mobileSearchParams: string
} {
  const isBedbank = isBedbankOffer(offer)
  const propertyId = offer.property.id
  const propertyName = isBedbank ? offer.name : offer.property.name

  // Add appropriate prefix to property ID if not already present
  const prefix = isBedbank ? 'bedbank' : 'le'
  const propertyIdWithPrefix = propertyId.includes(':') ? propertyId : `${prefix}:${propertyId}`

  const propertySearchItem: App.SearchItem = {
    searchType: 'property',
    value: propertyIdWithPrefix,
    format: {
      mainText: propertyName,
    },
  }
  const existingParams = new URLSearchParams(window.location.search)
  const searchParams = new URLSearchParams()

  searchParams.set('propertyId', propertyIdWithPrefix)
  searchParams.set('propertyName', propertyName)

  if (existingParams.has('checkIn')) searchParams.set('checkIn', existingParams.get('checkIn')!)
  if (existingParams.has('checkOut')) searchParams.set('checkOut', existingParams.get('checkOut')!)
  if (existingParams.has('adults')) searchParams.set('adults', existingParams.get('adults')!)
  if (existingParams.has('children')) searchParams.set('children', existingParams.get('children')!)

  return {
    propertyId: propertyIdWithPrefix,
    propertyName,
    propertySearchItem,
    mobileSearchParams: searchParams.toString(),
  }
}
